import React from "react";
import IconoConjuntos from '../../../medatatheme/assets/icons/group-data/stat-conjuntos.png';
import IconoDependencias from '../../../medatatheme/assets/icons/group-data/stat-dependencias.png';
import IconoTableros from '../../../medatatheme/assets/icons/group-data/stat-tableros.png';
import IconoVisitas from '../../../medatatheme/assets/icons/group-data/stat-visitas.png';
import IconoDescargas from '../../../medatatheme/assets/icons/group-data/stat-descargas.png';

const HomeDataSets = ({
  dataLength,
  publishersLength,
  boardsLength,
  visits,
  downloads
}) => {
  // Los 5 indicadores, en una sola fila (cuadros amarillos del diseño).
  const stats = [
    { icon: IconoConjuntos, number: dataLength, label: 'Número de conjuntos de datos' },
    { icon: IconoDependencias, number: publishersLength, label: 'Dependencias con datos publicados' },
    { icon: IconoTableros, number: boardsLength, label: 'Número de tableros de análisis' },
    { icon: IconoVisitas, number: visits, label: 'Número de visitas' },
    { icon: IconoDescargas, number: downloads, label: 'Número de descargas' },
  ];

  return (
    <div className="data-group">
      <p className="title title--black">
        Información sobre conjunto de datos
      </p>
      <hr className="separator separator--black" />
      <p className="text">
        Los datos abiertos son información pública, dispuesta en diferentes formatos, que permite su uso y reutilización bajo licencia abierta y sin restricciones legales para su aprovechamiento.</p>
      <p className="text">
        ¿Para qué pueden servirte los datos abiertos de MEData? Te damos algunas ideas:
      </p>
      <p className="text">
        Planear tus procesos y negocios.<br />
        Hacer veeduría a la Administración Pública.<br />
        Diseñar productos.<br />
        Escribir artículos.<br />
        Basar tus investigaciones en información de primera mano.<br />
        Conocer a Medellín y sus múltiples realidades.<br />
      </p>
      <div className="data-stats-row">
        {stats.map((stat, idx) => (
          <div className="data-stat" key={idx}>
            {/* La imagen del cuadro amarillo ya incluye el ícono y la etiqueta. */}
            <img className="data-stat-card" src={stat.icon} alt={stat.label} />
            <p className="data-stat-number">{stat.number}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeDataSets;
